import { Space } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./RuleCard.module.scss"

import type { ActionsRuleCardProps } from "./RuleCard.types"

export const ActionsRuleCard = (props: ActionsRuleCardProps) => {
  const { actions } = props
  const { enabled } = actions
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.actions"
  })

  return (
    <Space
      className={styles.space}
      separator={<span className={styles.separator}>•</span>}
    >
      {enabled && actions.enforceRuleOnRuntime && <span>Block</span>}
      {enabled && actions.notifyOnViolation && <span>Notify</span>}
      {enabled && actions.preventViolationOnDevelopment && <span>Prevent</span>}
      {enabled && actions.monitorOnViolation && <span>{t("MONITOR")}</span>}
    </Space>
  )
}
